import { render, staticRenderFns } from "./Result.More.vue?vue&type=template&id=50e920c2&"
import script from "./Result.More.vue?vue&type=script&lang=js&"
export * from "./Result.More.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports